import React,{ useEffect,useState } from 'react';
import Input from '../Common/Input';
import InputMask from '../Common/InputMask';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from '../Common/ReactSelect';

const Form = ({ formik,id = null }) => {

    const [business,setBusiness] = useState([]);
    const {readData: getBusiness} = useEntityCrud('Business/GetAllBusiness');
    const [roles,setRoles] = useState([]);
    const {readData: getRoles} = useEntityCrud('Role/GetAllRole');
    const [guilds,setGuilds] = useState([]);
    const {readData: getGuilds} = useEntityCrud('Guild/GetAllGuilds');

    useEffect(() => {
        getRoles().then(({data}) => {
            let rolesData = [];
            if(data.status)
                data.result.map(item => {
                    rolesData.push({
                        label: item.title,
                        businessEnable: item.businessEnable == true,
                        value: item.id
                    });
                })
            setRoles(rolesData);
        });
        getGuilds().then(({data}) => {
            let guildsData = [];
            if(data.status)
                data.result.map(item => {
                    if(item.isActive)
                        guildsData.push({
                            label: item.title,
                            value: item.id
                        });
                });
            setGuilds(guildsData)
        });
        getBusiness().then(({data}) => {
            let businesses = [];
            if(data.status)
                data.result.map(item => {
                    if(item.isActive)
                        businesses.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBusiness(businesses)
        });
    },[]);
    
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <Input label="نام" name="name" required={true} formik={formik} />
                </div>
                <div className="col-md-3">
                    <Input label="نام خانوادگی" name="lastName" required={true} formik={formik} />
                </div>
                <div className="col-md-3">
                    <Input label="کد ملی" name="nationalCode" required={true} isLtr={true} formik={formik} type="tel" maxLength="10" />
                </div>
                <div className="col-md-3">
                    <Input label="رمز عبور" name="password" required={!id} isLtr={true} formik={formik} type="password" min="6" />
                </div>
                <div className="col-md-3">
                    <InputMask label="شماره همراه" name="phone" required={true} formik={formik} isLtr={true} type="tel" mask="9999-9999999" />
                </div>
                <div className="col-md-3">
                    <ReactSelect label="نقش" name="roleId" formik={formik} required={true} value={roles.find(r => r.value == formik.values.roleId)} options={roles} />
                </div>
                {roles.find(r => r.value == formik.values.roleId)?.businessEnable ? <><div className="col-md-3">
                    <ReactSelect label="صنف" name="guildId" formik={formik} value={guilds.find(g => g.value == formik.values.guildId)} options={guilds} isDisabled={!formik.values.roleId} />
                </div><div className="col-md-3">
                    <ReactSelect label="کسب و کار" options={business} isMulti={true} name="businessId" formik={formik} required={!id} value={formik.values.businessId} />
                </div></> : ''}
               
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;